import React, { useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { UserContext } from "../context/userContext";

const Login = () => {
  const [userData, setUserData] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const { setCurrentUser } = useContext(UserContext);

  const changeInputHandler = (e) =>
    setUserData((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const loginUser = async (e) => {
    e.preventDefault();
    setError("");
    setIsSubmitting(true);
    try {
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/users/login`, userData);
      setCurrentUser(response.data);
      navigate("/");
    } catch (err) {
      setError(err.response?.data?.message || "Couldn't sign you in.");
    }
    setIsSubmitting(false);
  };

  return (
    <section className="auth">
      <div className="card auth__card reveal">
        <div className="auth__head">
          <span className="brand__mark">B</span>
          <h1>
            Welcome <span className="ink-italic">back.</span>
          </h1>
          <p>Sign in to write, edit and manage your posts.</p>
        </div>

        <form className="form" onSubmit={loginUser}>
          {error && <p className="alert">{error}</p>}
          <div className="field">
            <label className="field__label" htmlFor="email">
              Email
            </label>
            <input
              id="email"
              className="input"
              type="email"
              name="email"
              placeholder="you@company.com"
              value={userData.email}
              onChange={changeInputHandler}
              autoComplete="email"
              autoFocus
            />
          </div>
          <div className="field">
            <label className="field__label" htmlFor="password">
              Password
            </label>
            <input
              id="password"
              className="input"
              type="password"
              name="password"
              placeholder="••••••••"
              value={userData.password}
              onChange={changeInputHandler}
              autoComplete="current-password"
            />
          </div>
          <button type="submit" className="btn btn--primary btn--block btn--lg" disabled={isSubmitting}>
            {isSubmitting ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <p className="auth__switch">
          New to BrainBytes? <Link to="/register">Create an account</Link>
        </p>
      </div>
    </section>
  );
};

export default Login;
